<template>
    <q-card class="q-dialog-plugin">
        <q-card-section v-if="!props?.mode" class="row items-center q-pb-none" style="padding: 2vmin 2vmin 1vmin; height: 7.17vmin">
            <q-space />
            <q-btn class="close" icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator v-if="!props?.mode" />
        <div style="padding: 2.5vmin; position: relative">
            <div class="row">
                <div class="col passage" style="height: calc(100vh - 12.27vmin)" :style="!props?.mode ? '' : 'height: calc( 100vh - 5vmin )'">
                    <!-- <div v-if="reviewData.reviewContents !== null" v-html="reviewData.reviewContents" />
                                        <qbankHeaderVue v-if="reviewData.reviewContents === null && questionHeader"
                                            :questionHeader="questionHeader" :bookNm="bookNm" :tooltipMsg="false" /> -->

                    <qbankHeaderVue :currentNo="currentNo" :questionHeader="reviewData.reviewContents === null ? questionHeader : reviewData.reviewContents" :bookNm="bookNm" :tooltipMsg="false" />
                </div>
                <div class="col answer" style="height: calc(100vh - 14.27vmin)" :style="!props?.mode ? '' : 'height: calc( 100vh - 5vmin )'">
                    <q-scroll-area ref="scrollAreaRef" visible class="answer__scroll" style="height: 100%" v-if="!relationDialog">
                        <div>
                            <!-- <ProblemChoiceEval2 :p-content="problem" v-if="problem" @setAnswer="setAnswer" /> -->
                            <!-- <ProblemChoiceEval :p-content="problem" :unit-no="props?.num" @setAnswer="setAnswer" /> -->
                            <ProblemChoice :p-content="problem" v-if="problem" @setAnswer="setAnswer" />
                        </div>
                        <div>
                            <QbankAnswer :p-content="problem" v-if="problem" @onIntersection="onIntersection" />
                        </div>
                    </q-scroll-area>
                    <div v-if="relationDialog">
                        <ProblemRelation
                            :p-content="problem"
                            v-if="problem"
                            :isViewMode="true"
                            @onClose="
                                () => {
                                    relationDialog = false;
                                }
                            "
                        />
                    </div>
                    <!-- <q-inner-loading :showing="isLoading" label="" label-class="text-teal"
                        label-style="font-size: 1.1em" /> -->
                </div>
            </div>
        </div>
        <FloatingBtn
            :visible="relation && nextBtn"
            @on-click="
                () => {
                    if (nextBtn) {
                        relationDialog = true;
                        nextBtn = false;
                    }
                }
            "
            class="answer--next"
        />
        <FloatingBtn
            position="left"
            :visible="relation && !nextBtn"
            @on-click="
                () => {
                    if (!nextBtn) {
                        relationDialog = false;
                        nextBtn = true;
                    }
                }
            "
            class="answer--prev"
        />
        <q-inner-loading :showing="isLoading" label="" label-class="text-teal" label-style="font-size: 1.1em" />
    </q-card>
</template>

<script setup>
import { onMounted, watch, ref, computed } from 'vue';
import { getKrtProblem } from '@/api/modules/qbank';
import { getReportReview, getReportDiagnosticReview } from '@/api/modules/study';
import qbankHeaderVue from '@/components/qbank/header.vue';
import ProblemChoice from '@/components/qbank/problemChoice.vue';
import ProblemChoiceEval from '@/views/eval_qbank/components/problemChoice_eval.vue';

import QbankAnswer from '@/components/qbank/qbankAnswer.vue';
import { getEtcInfo, getHeader } from '@/helpers/qbankParser/qbankDataParse';
import { analysis } from '@/helpers/qbankParser/qbankMeta';
import { getCircularAnswer } from '@/helpers/utils';
import FloatingBtn from '@/components/quasar/floatingBtn.vue';
import ProblemRelation from '@/components/qbank/problemRelation.vue';

const props = defineProps({
    answerHistorySeq: { default: '0' },
    mode: { default: null },
    type: { default: null },
    num: { default: null },
    numLeft: { default: '' },
});

const currentNo = computed(() => { 
    return props.numLeft;
});

const studyTree = ref('5083');
const questionHeader = ref(null);
const bookNm = ref(null);
const isLoading = ref(true);
const qBankData = ref(null);
const nextBtn = ref(true);
const relation = ref(false);
const relationDialog = ref(false);
const reviewData = ref({
    reviewContents: null,
    problemId: '',
    correct: '',
    answer: '',
    reAnswer: '',
    correctYn: '',
    reCorrectYn: '',
    problemClassCode: '',
    exprSyncVersion: '',
});
const problem = ref(null);

const onIntersection = () => {};
const setAnswer = () => {};
const getData = (seq) => {
    const setData = (r) => {
        reviewData.value = { ...r, correctYn: r.correctYn === 'Y' };
        getKrtProblem({ version: r.exprSyncVersion, problemId: r.problemId }, (rs) => {
            qBankData.value = rs;
            const tmpStudyTree = rs.content.property.analysis.studyTreeId;
            const tmpEtcInfo = getEtcInfo(rs);
            bookNm.value = tmpEtcInfo.bookNm;
            studyTree.value = tmpStudyTree;
            questionHeader.value = getHeader(rs);
            // console.log(questionHeader.value);
            problem.value = {
                problemNo: props?.num ? props?.num : analysis[rs.content.property.analysis.analysisId]['ord'],
                problemId: r.problemId,
                analysisOrd: analysis[rs.content.property.analysis.analysisId]['ord'],
                etcInfo: tmpEtcInfo,
                data: rs,
                type: null,
                elapsedTime: 0,
                answer: r.answer,
                reAnswer: r.reAnswer,
                markingType: r.correctYn ? 'right' : r.reCorrectYn ? 'halfRight' : 'wrong', //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
                videoTime: 0,
                relationResult: true,
                // 하단 네비 조정을 위한 변수
                result: {
                    marking: r.correctYn ? 'right' : r.reCorrectYn ? 'halfRight' : 'wrong',
                    answer: r.answer,
                }, // 채점 여부및 1,2차 정오답
                done: true, // 채점및 풀이 확인 완료여부
                scrollCheck: true, // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
                relationId: rs.content.property.problem?.relations?.length > 0 ? rs.content.property.problem?.relations[0].relationId : null, // 확인 문제 있는지 여부
                completeVideo: true, // 영상 시청 여부
                // videoUrl: null,              // 해설 영상 여부
                videoUrl: rs.content.property.problem.listen.includes('mp4') ? process.env.VUE_APP_DS_QBANK_ASSET_URL + rs.content.property.problem.listen : null,
                // videoUrl: rs.content.property.problem.listen !== '' ? process.env.VUE_APP_DS_QBANK_ASSET_URL + rs.content.property.problem.listen : null,
                // videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
                problemClassCode: r.problemClassCode,
                completeYn: true,
            };
            isLoading.value = false;
            if (r.correctYn === false && r.reCorrectYn === false && rs.content.property.problem?.relations?.length > 0) {
                relation.value = true;
            }
        });
    };
    if (props.type === 'diagnostic') {
        getReportDiagnosticReview({ diagnosticAnswerHistorySeq: seq }, (r) => {
            // TODO: correctYn => T/F 로 벡엔드 작업이 선행 되면 변경해야함
            setData({ ...r, answer: getCircularAnswer(r.answer) });
        });
    } else {
        getReportReview({ answerHistorySeq: seq }, (r) => {
            setData(r);
        });
    }
};
onMounted(() => {
    // console.log('onMounted');
    // console.log(props.answerHistorySeq);
    if (props.answerHistorySeq) {
        getData(props.answerHistorySeq);
    }
});

watch(
    () => props.answerHistorySeq,
    (newValue) => {
        // console.log('onMounted');
        // console.log(props.answerHistorySeq);
        if (newValue) {
            getData(newValue);
        }
    },
);
</script>

<style scoped lang="scss">
.passage {
    + .answer {
        &::before {
            content: '';
            position: absolute;
            top: 46%;
            left: 0;
            width: 1px;
            height: 91%;
            max-height: 974px;
            background: $color_gray_500;
            @include transform(translateY(-50%));
        }
    }
}

.answer {
    position: relative;
    // padding: 0 4.17vmin;

    &__scroll {
        padding: 0 5.17vmin 3.33vmin 4.08vmin;
        // padding-right: 5.17vmin;
        // padding-bottom: 3.33vmin;
    }
}

::v-deep {
    .q-scrollarea__content {
        padding-bottom: 3.33vmin;
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}
</style>
